<span [tooltip]="value | currency:currencyCode:'symbol':tooltipDigitsInfo" class="wrapped" container="body" delay="500">{{value | shortCurrency:currencyCode:maxDecimalPrecision}}</span>
